import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import _ from 'lodash';
import config from '../../../../app/config';
import {UtilsMomentJS} from '../../../../store/utilsMoment';
import {useStylesECDS} from './ecdsStyle';
import InformationBox from '../../../../components/other/informationBox';
import {AgyleTable, createAgyleTableColumn} from '../../../../components/table/AgyleTable';

const COLUMNS_V3 = [
    createAgyleTableColumn('no', 'No.', 1, null, 'count', 'notSort', 'medium', 'center', true, false, null, null, null),
    createAgyleTableColumn('invest', 'Investigation', 2, 'EmergencyCareClinicalInvestigation_SnomedCt', 'dict', '', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('date', 'Procedure Date', 3, 'date', 'string', '', 'medium', 'left', true, true, null, null, null),
    createAgyleTableColumn('time', 'Procedure Time', 4, 'time', 'string', '', 'medium', 'left', true, false, null, null, null),
];

const COLUMNS_V4 = [
    createAgyleTableColumn('no', 'No.', 1, null, 'count', 'notSort', 'medium', 'center', true, false, null, null, null),
    createAgyleTableColumn('invest', 'Investigation', 2, 'EmergencyCareClinicalInvestigation_SnomedCt', 'dict', '', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('timestamp', 'Procedure Timestamp', 3, 'timestamp', 'date', '', 'medium', 'left', true, true, null, null, null),
];

const Investigations = (props) => {
    const {t} = useTranslation();
    const classes = useStylesECDS();
    const {version} = props;

    // Multi Entry list
    const [list, setList] = useState([]);

    const setDataDictionary = () => {
        let formattedList = _.cloneDeep(list);
        for (const element of formattedList) {
            element.EmergencyCareClinicalInvestigation_SnomedCt = element.EmergencyCareClinicalInvestigation_SnomedCt?.snomedCode || null;
            delete element.date;
            delete element.time;
        }
        const data = {EmergencyCareInvestigations_SnomedCt: formattedList};
        props.setData(data);
    };

    useEffect(() => {
        let data = [];
        if (!_.isEmpty(props.patient?.triage?.investigations)) {
            props.patient.triage.investigations.map((code) => {
                if (code.value) {
                    data.push({
                        EmergencyCareClinicalInvestigation_SnomedCt: code?.value || '-',
                        ProcedureDate_EmergencyCareClinicalInvestigation: code?.procedureDate || '-',
                        ProcedureTime_EmergencyCareClinicalInvestigation: code?.procedureTime || '-',
                        CodedProcedureTimestamp_UrgentAndEmergencyCareClinicalInvestigation: code?.timestamp,
                        date: getLocalDateText(code, 'date'),
                        time: getLocalDateText(code, 'time'),
                        timestamp: code?.procedureTimestamp || '-',
                    });
                }
            });
            setList([...data]);
        }
    }, []);

    useEffect(() => {
        setDataDictionary();
    }, [list]);

    const getLocalDateText = (obj, type) => {
        const local = UtilsMomentJS.getLocalDateFromUTCECDSFormat(obj.procedureDate, obj.procedureTime);
        if (local) return type === 'date' ? local.format(config.defaultDateFormat) : local.format(config.defaultTimeFormat);
        return '-';
    };

    if (props.accordion !== 'Emergency Care Investigations' && props.accordion !== 'Urgent And Emergency Care Investigations') return null;

    return (
        <div className={classes.root}>
            {!_.isEmpty(list) &&
                <AgyleTable
                    columns={version === 'V3' ? COLUMNS_V3 : COLUMNS_V4}
                    data={list}
                    disableFilter
                />
            }
            {_.isEmpty(list) &&
                <InformationBox type="info">
                    {t('No Investigations Set.')}
                </InformationBox>
            }
        </div>
    );
};

export default Investigations;
